import type { RootState } from "Data/Store/Store";
import type { CartItem } from "@model/Cart.model";

export const selectCartItems = (state: RootState): CartItem[] => {
  const itemsById = state.cartReducer?.itemsById ?? {};
  return Object.values(itemsById);
};

export const selectCartTotalQuantity = (state: RootState): number =>
  selectCartItems(state).reduce((sum, it) => sum + Number(it.quantity ?? 0), 0);

export const selectCartSubtotal = (state: RootState): number =>
  selectCartItems(state).reduce(
    (sum, it) => sum + Number(it.price ?? 0) * Number(it.quantity ?? 0),
    0
  );

export const selectCartQuantityById = (state: RootState, id: string): number => {
  const item = state.cartReducer?.itemsById?.[id];
  return Number(item?.quantity ?? 0);
};

export const selectCartItemById = (state: RootState, id: string): CartItem | undefined =>
  state.cartReducer?.itemsById?.[id];

export const selectCartIsEmpty = (state: RootState): boolean =>
  selectCartItems(state).length === 0;
